"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var iconButton_1 = require("../../action/iconButton");
var Notification = /** @class */function (_super) {
  __extends(Notification, _super);
  function Notification() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Notification.prototype.render = function () {
    var Transition = this.props.lib.Transition;
    return react_1.default.createElement(Transition, {
      as: react_1.Fragment,
      show: this.props.notificationAttribute.visible,
      enter: "transform transition duration-[400ms]",
      enterFrom: "opacity-0 scale-50",
      leave: "transform duration-200 transition ease-in-out",
      leaveTo: "opacity-0 scale-95 "
    }, react_1.default.createElement("div", {
      "aria-live": "assertive",
      className: "fixed inset-0 flex items-end px-4 py-6 pointer-events-none z-50 sm:p-6 sm:items-start"
    }, react_1.default.createElement("div", {
      className: "w-full flex flex-col items-center space-y-4 sm:items-end"
    }, react_1.default.createElement("div", {
      className: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden"
    }, react_1.default.createElement("div", {
      className: "p-4"
    }, react_1.default.createElement("div", {
      className: "flex items-center"
    }, react_1.default.createElement("div", {
      className: "flex-shrink-0"
    }, this.props.icon), react_1.default.createElement("div", {
      className: "ml-3 w-0 flex-1 pt-0.5"
    }, react_1.default.createElement("p", {
      className: "text-sm font-medium text-gray-900"
    }, this.props.notificationAttribute.title), react_1.default.createElement("p", {
      className: "mt-1 text-sm text-gray-500"
    }, this.props.notificationAttribute.desc)), react_1.default.createElement("div", {
      className: "ml-4 flex-shrink-0 flex"
    }, react_1.default.createElement(iconButton_1.IconButton, {
      icon: react_1.default.createElement(outline_1.XMarkIcon, {
        className: "h-5 w-5 text-gray-400"
      }),
      onClick: this.props.onClose
    }))))))));
  };
  return Notification;
}(react_1.Component);
exports.Notification = Notification;